var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOeIconLrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 16.1,
    viewBox: "0 0 23 16.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "oe_icon_lrg",
    "data-name": "Open Ended Icon Large",
    d: "M9.5,11.94H30.2a1.15,1.15,0,0,0,0-2.3H9.5a1.15,1.15,0,1,0,0,2.3Zm15.7,2.3H9.5a1.15,1.15,0,1,0,0,2.3H25.2a1.15,1.15,0,0,0,0-2.3Zm5,4.6H15.5a1.15,1.15,0,1,0,0,2.3H30.2a1.15,1.15,0,0,0,0-2.3Zm0,4.6H9.5a1.15,1.15,0,1,0,0,2.3H30.2a1.15,1.15,0,0,0,0-2.3Z",
    transform: "translate(-8.354 -9.64)",
    fill: "#8f6aea"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOeIconLrg);
export default __webpack_public_path__ + "static/media/oe_icon_lrg.4ab8ec412e00dd70b95acaef06551cc0.svg";
export { ForwardRef as ReactComponent };